module.exports = __webpack_public_path__ + "static/img/pet-01.893585c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/pet-01.jpg
// module id = rZWi
// module chunks = 0